import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import GConf from '../../AssetsM/generalConf';

function RecetteCamionTemp() {
     let camData = JSON.parse(localStorage.getItem(`${GConf.SystemTag}_Camion_LocalD`));
    const Cam_ID = camData.Cam_ID;
    const Cam_Name = camData.Cam_Name;
    const Matricule = camData.Matricule;
    let [totale, setTotale] = useState('0,000')
    let [totaleDep, setTotaleDep] = useState('0,000')
    let [printBtnState, setPrintBtnState] = useState(false)
    let [loaderState, setLS] = useState(true)

    useEffect(() => {
        axios.post(`${GConf.ApiCamionLink}/rt/imprimer`, {
            tag: GConf.SystemTag,
            camId : Cam_ID,
          })
          .then(function (response) {
              setTotale(response.data[0].Totale)
              setTotaleDep(response.data[0].TotDepense)
              setLS(false)
          }).catch((error) => {
              if(error.request) {
                setTotale('0,000')
                setTotaleDep('0,000')
                setLS(false)
              }
          });
    }, [])

     

    return ( <>
           <div className="container mb-2 mt-4">
            <div style={{border:'2px solid black', padding : 15, borderRadius : 10}}>
                <h2 className='text-center mb-1'>Recette Le : {new Date().toLocaleDateString('fr-FR').split( '/' ).reverse( ).join( '-' )} </h2> 
                <h4 className='text-center mt-1'>Camion : {Cam_Name} | {Matricule} </h4> 
            </div>
                <br />
                <br />
            <div style={{border:'2px solid black', padding : 15, borderRadius : 10}}>
                TOTALE VENTE : 
                <br />
                {totale} TND
            </div>
                <br />
            <div style={{border:'2px solid black', padding : 15, borderRadius : 10}}>
                TOTALE DEPENSE : 
                <br />
                {totaleDep} TND
                <br />
                LISTE DES DEPENSE : 
                <br />
                .................................................................................<br />
                .................................................................................<br />
                .................................................................................<br />
                .................................................................................<br />
                 
            </div>
                <br />
                 
            </div>
             
           <div style={{border:'2px solid black', padding : 15, borderRadius : 10}}>
            <div><b>Net : {totale - totaleDep}</b></div>
          </div>
           
    </> );
}

export default RecetteCamionTemp;